<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps<{
  error: NuxtError
}>()

const router = useRouter()
</script>

<template>
  <UApp :toaster="{ position: 'bottom-center', duration: 10000 }">
    <UError :error="error">
      <template #links>
        <UButton @click="clearError({ redirect: '/' })">
          Gå til forsiden
        </UButton>
        <UButton @click="router.go(-1)">
          Gå tilbage
        </UButton>
      </template>
    </UError>
  </UApp>
</template>
